export default __webpack_public_path__ + "static/media/meninasnacomputacao.dd21c588.png";